export const category = {
  zh: {
    financial: {
      title: "財務",
      subtitle: "Financial",
    },
    valuation: {
      title: "估值",
      subtitle: "Valuation",
    },
    growth: {
      title: "成長能力",
      subtitle: "Growth",
    },
    profitability: {
      title: "獲利能力",
      subtitle: "Profitability",
    },
  },
  en: {
    financial: {
      title: "Financial",
      subtitle: "Financial",
    },
    valuation: {
      title: "Valuation",
      subtitle: "Valuation",
    },
    growth: {
      title: "Growth",
      subtitle: "Growth",
    },
    profitability: {
      title: "Profitability",
      subtitle: "Profitability",
    },
  },
};
